import React, { useState } from 'react';
import { useAppStore } from '../../store/appStore';
import GroupsManagerModal from '../camera/GroupsManagerModal';

export default function TopBar() {
  const { searchQuery, setSearchQuery, activeView, setActiveView, activePanel, filterStatus, setFilterStatus, filterGroup, setFilterGroup, groups } = useAppStore();
  const [showGroupsManager, setShowGroupsManager] = useState(false);

  return (
    <div style={{
      height: '52px',
      background: 'var(--bg-surface)',
      borderBottom: '1px solid var(--border-dim)',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      padding: '0 16px',
      flexShrink: 0,
    }}>
      {/* Clock */}
      <LiveClock />
      
      <div style={{ width: '1px', height: '24px', background: 'var(--border-dim)', flexShrink: 0 }} />

      {activePanel === 'cameras' && (
        <>
          {/* Search */}
          <div style={{ position: 'relative', flex: '1', maxWidth: '320px' }}>
            <svg style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }}
              width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
            </svg>
            <input
              className="input-field"
              style={{ paddingLeft: '32px', height: '32px', fontSize: '13px' }}
              placeholder="Search cameras..."
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Status filter */}
          <select
            className="input-field select-field"
            style={{ width: '130px', height: '34px', fontSize: '12px', fontFamily: 'var(--font-display)', letterSpacing: '0.05em', padding: '4px 28px 4px 10px', lineHeight: 'normal' }}
            value={filterStatus || ''}
            onChange={e => setFilterStatus(e.target.value || null)}
          >
            <option value="">All Status</option>
            <option value="online">Online</option>
            <option value="offline">Offline</option>
          </select>

          {/* Group filter */}
          <select
            className="input-field select-field"
            style={{ width: '140px', height: '34px', fontSize: '12px', fontFamily: 'var(--font-display)', letterSpacing: '0.05em', padding: '4px 28px 4px 10px', lineHeight: 'normal' }}
            value={filterGroup || ''}
            onChange={e => setFilterGroup(e.target.value || null)}
          >
            <option value="">All Groups</option>
            {groups.map(g => (
              <option key={g.id} value={g.id}>{g.name}</option>
            ))}
          </select>

          {/* Manage Groups button */}
          <button
            className="btn btn-ghost btn-sm"
            onClick={() => setShowGroupsManager(true)}
            title="Manage Groups"
            style={{ flexShrink: 0 }}
          >
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ marginRight: '4px' }}><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/></svg>
            Groups
          </button>

          <div style={{ flex: 1 }} />

          {/* View toggle */}
          <div style={{
            display: 'flex',
            background: 'var(--bg-primary)',
            border: '1px solid var(--border-normal)',
            borderRadius: 'var(--radius-md)',
            overflow: 'hidden',
          }}>
            {['list', 'grid', 'map'].map(view => (
              <button
                key={view}
                onClick={() => setActiveView(view)}
                style={{
                  padding: '5px 10px',
                  border: 'none',
                  background: activeView === view ? 'var(--accent-cyan)' : 'transparent',
                  color: activeView === view ? 'var(--bg-void)' : 'var(--text-secondary)',
                  cursor: 'pointer',
                  fontFamily: 'var(--font-display)',
                  fontSize: '11px',
                  fontWeight: 600,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  transition: 'all 0.15s',
                }}
              >
                {view === 'list' ? <ListIcon /> : view === 'grid' ? <GridIcon /> : <MapIcon />}
              </button>
            ))}
          </div>
        </>
      )}

      {activePanel !== 'cameras' && <div style={{ flex: 1 }} />}

      {showGroupsManager && <GroupsManagerModal onClose={() => setShowGroupsManager(false)} />}

      {/* Record indicator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'var(--font-mono)', fontSize: '11px', color: 'var(--text-muted)' }}>
        <span className="status-dot online animate-pulse" />
        LIVE
      </div>
    </div>
  );
}

function LiveClock() {
  const [time, setTime] = React.useState(new Date());
  React.useEffect(() => {
    const i = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(i);
  }, []);
  return (
    <div style={{ fontFamily: 'var(--font-mono)', fontSize: '12px', color: 'var(--text-muted)', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>
      {time.toUTCString().slice(0, 25)} UTC
    </div>
  );
}

function ListIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>; }
function GridIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>; }
function MapIcon() { return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>; }
